<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px"
          class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('base.eightBitCode.eightBitCode')" prop="eightBitCode">
                    <el-input v-model.trim="queryCondition.eightBitCode" style="width:100%" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('base.eightBitCode.eightBitCodeName')" prop="eightBitCodeName">
                    <el-input v-model="queryCondition.eightBitCodeName" style="width:100%" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工厂编号" prop="plantNo">
                    <el-input v-model.trim="queryCondition.plantNo" style="width:100%" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工厂名称" prop="plantName">
                    <el-input v-model.trim="queryCondition.plantName" style="width:100%" clearable />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="供应商编号" prop="supplierCode">
                      <el-input v-model.trim="queryCondition.supplierCode" style="width:100%" clearable />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="供应商名称" prop="supplierName">
                      <el-input v-model="queryCondition.supplierName" style="width:100%" clearable />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="物料产品状态" prop="status">
                      <ic-select table="TM_MATERIAL" class="handle-input" field="STATUS" v-model="queryCondition.status"
                        clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="提货点" prop="pickupPoint">
                      <el-input v-model.trim="queryCondition.pickupPoint" style="width:100%" clearable />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="DC" prop="dcName">
                      <el-input v-model="queryCondition.dcName" style="width:100%" clearable />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="温区" prop="temperature">
                      <ic-select table="COMMON" class="handle-input" field="TEMPERATURE"
                        v-model="queryCondition.temperature" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" class="btn" @click="queryData(1)" type="primary">{{ $t('common.search') }}</el-button>
            <el-button size="mini" @click="restQueryForm()" type="primary">{{ $t('common.reset') }}</el-button>
            <span class="arrowDown" @click="isShow = !isShow">{{ isShow ? '收缩' : '展开' }}<i
                :class="isShow ? 'el-icon-arrow-up iconBtn' : 'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" border max-height='1610' highlight-current-row class="table">
        <el-table-column show-overflow-tooltip prop="eightBitCode" sortable label="8位码" fixed min-width="90">
          <template slot-scope="scope">
            <div class="a-link" @click="toDetail(scope.row)">{{ scope.row.eightBitCode }}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="180" prop="eightBitCodeName" show-overflow-tooltip sortable
          label="8位码名称"></el-table-column>
        <el-table-column min-width="90" prop="plantNo" show-overflow-tooltip sortable label="工厂编号"></el-table-column>
        <el-table-column min-width="110" prop="plantName" show-overflow-tooltip sortable label="工厂名称"></el-table-column>
        <el-table-column min-width="100" prop="supplierCode" show-overflow-tooltip sortable
          label="供应商编号"></el-table-column>
        <el-table-column min-width="120" prop="supplierName" show-overflow-tooltip sortable
          label="供应商名称"></el-table-column>
        <el-table-column min-width="120" prop="statusI18n" show-overflow-tooltip sortable
          label="物料产品状态"></el-table-column>
        <el-table-column min-width="80" prop="temperatureI18n" show-overflow-tooltip sortable
          label="温区"></el-table-column>
        <el-table-column min-width="80" prop="sixBitCode" show-overflow-tooltip sortable label="六位码"></el-table-column>
        <el-table-column min-width="200" prop="sixBitCodeName" show-overflow-tooltip sortable
          label="六位码名称"></el-table-column>
        <el-table-column min-width="120" prop="externalPackagingLength" show-overflow-tooltip sortable
          label="外包装长(cm)"></el-table-column>
        <el-table-column min-width="120" prop="externalPackagingWidth" show-overflow-tooltip sortable
          label="外包装宽(cm)"></el-table-column>
        <el-table-column min-width="120" prop="externalPackagingHeight" show-overflow-tooltip sortable
          label="外包装高(cm)"></el-table-column>
        <el-table-column min-width="130" prop="externalPackagingNetweight" show-overflow-tooltip sortable
          label="外包装净重(kg)"></el-table-column>
        <el-table-column min-width="130" prop="externalPackagingGrossweight" show-overflow-tooltip sortable
          label="外包装毛重(kg)"></el-table-column>
        <el-table-column min-width="120" prop="palletLayerNumber" show-overflow-tooltip sortable
          label="每Pallet层数"></el-table-column>
        <el-table-column min-width="100" prop="palletLayerBoxNumber" show-overflow-tooltip sortable
          label="每层箱数"></el-table-column>
        <el-table-column min-width="80" prop="fiveBitCode" show-overflow-tooltip sortable label="五位码"></el-table-column>
        <el-table-column min-width="100" prop="fiveBitCodeName" show-overflow-tooltip sortable
          label="五位码名称"></el-table-column>
        <el-table-column min-width="160" prop="categoryLevel1Code" show-overflow-tooltip sortable
          label="CategoryLevel1Code"></el-table-column>
        <el-table-column min-width="170" prop="categoryLevel1Name" show-overflow-tooltip sortable
          label="CategoryLevel1Name"></el-table-column>
        <el-table-column min-width="160" prop="categoryLevel2Code" show-overflow-tooltip sortable
          label="CategoryLevel2Code"></el-table-column>
        <el-table-column min-width="170" prop="categoryLevel2Name" show-overflow-tooltip sortable
          label="CategoryLevel2Name"></el-table-column>
        <el-table-column min-width="160" prop="categoryLevel3Code" show-overflow-tooltip sortable
          label="CategoryLevel3Code"></el-table-column>
        <el-table-column min-width="170" prop="categoryLevel3Name" show-overflow-tooltip sortable
          label="CategoryLevel3Name"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange"
          :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize"
          :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>

    <!--到货仓库选择-->
    <el-dialog :visible.sync="showSelDcDialog" append-to-body width="80%">
      <SelDc ref="selectDcRef" :multipleSelectionFlag="true" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
  </div>
</template>
<script>
import { materialService } from "../../../api/base-data/material";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "../../../utils/dataTableUtils"
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
export default {
  name: 'material',
  mixins: [paginationMixin],
  components: { IcSelect, SelDc },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      tableData: [],
      totalCount: 0,
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: '',
        eightBitCodeName: '',
        plantNo: '',
        plantName: '',
        supplierCode: '',
        supplierName: '',
        pickupPoint: '',
        dcName: '',
        temperature: '',
      },
      showSelDcDialog: false,
      tempRows: null,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    materialService.getMaterialData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  created() {
    // this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      materialService.getMaterialData(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    restQueryForm() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: '',
        eightBitCodeName: '',
        plantNo: '',
        plantName: '',
        supplierCode: '',
        supplierName: '',
        pickupPoint: '',
        dcName: '',
        temperature: '',
      }
      this.queryData(1);
    },
    toDetail(row) {
      let materilId = row.tmMaterialId
      if (this.actionCheck.actionCheck('MaterialViewDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.push({
        path: `/material-detail`,
        query: { materilId: materilId }
      });
    },
    showSelDcDialogFunc: function (row) {
      this.tempRows = row;
      this.showSelDcDialog = true;
    },
    //提交点选择
    selectDcMethod: function (dcList) {
      let _this = this;
      let oldName = _this.tempRows.dcName;
      let codes = new Array();
      let ids = new Array();
      dcList.forEach(((item) => {
        ids.push(item.tmDcId);
        codes.push(item.dcName);
      }))
      _this.tempRows.dcName = codes.join(",");
      materialService.updateMaterialDc(ids, _this.tempRows.tmMaterialId).then((res) => {
        if (res.code == '200') {
          Message({ message: this.$t('common.updateSuccess'), type: "success" });
          _this.showSelDcDialog = false;
        }
      }).catch(() => {
        _this.tempRows.dcName = oldName;
      });
      _this.showSelDcDialog = false;
    },

  },
  extends: commonFunction
}
</script>
<style scoped>
.query-btn-row {
  width: 30%;
  float: right;
}

.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}

.dialog-input {
  width: 40%;
}

.el-select {
  width: 100%;
}
</style>
